import { BadgeCheck } from "lucide-react";

export default function VerifiedBadge({ size = 14, className = "" }) {
  return (
    <span title="Terverifikasi" className={`inline-flex items-center text-bizma-sage ${className}`} data-testid="verified-badge">
      <BadgeCheck size={size} className="fill-bizma-sage text-white" />
    </span>
  );
}
